import React, { useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import _debounce from "lodash/debounce";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import {
    checkInOutColumn,
    confirmedColoumn,
    createActionColumn,
    getTdProps,
    getTdPropsV7,
    reconfirmedColoumn,
    sharedColumns,
    sharedProps,
} from "./helpers/tableProps";
import ReactTable from "components/ReactTable";

const TableWrapper = (props) => {
    const dispatch = useDispatch()
    const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
        dispatch(() => props.onSortedChange(sortBy));
        dispatch(() => props.onFilteredChange(filters));
        dispatch(() => props.onPageSizeChange(pageSize));
        dispatch(() => props.onPageChange(pageIndex));
    }, []);

    return (
        <ReactTable
            {...sharedProps}
            loading={props.isLoading}
            data={props.jobs}
            columns={[
                ...sharedColumns,
                confirmedColoumn,
                reconfirmedColoumn,
                checkInOutColumn,
                createActionColumn(),
            ]}
            fetchData={fetchData}
            defaultFilter={props.pageFilter}
            currentPage={props.currentPage}
            defaultPageSize={props.pageSize}
            pageCount={props.totalCount}
            defaultSort={props.pageSort}
            onRowClick={getTdPropsV7}
            hiddenColumns={props.hiddenColumns}
        />
    )
}

class ActiveTodayTable extends React.Component {
    render() {
        return (
            <TableWrapper {...this.props} />
        );
    }
}

const mapState = state => {
    const { pageCount, pageSize, currentPage, isLoading ,totalCount} = JobSelectors.getTodayActivePaginationData(
        state
    );
    return {
        jobs: JobSelectors.getListData(state, {
            timeframe: "today",
            status: "active",
            part: "data",
        }),
        pageFilter: JobSelectors.getListData(state, {
            timeframe: "today",
            status: "active",
            part: "filter",
        }),
        pageSort: JobSelectors.getListData(state, {
            timeframe: "today",
            status: "active",
            part: "sort",
        }),
        pageCount,
        pageSize,
        currentPage,
        isLoading,
        totalCount
    };
};
const mapAction = {
    fetchJobs: JobActions.fetchTodayActiveJobs,
    onPageChange: JobActions.fetchTodayActiveJobs,
    onSortedChange: JobActions.setTodayActiveSort,
    onFilteredChange: JobActions.setTodayActiveFilter,
    onPageSizeChange: JobActions.setTodayActivePageSize,
};

export default connect(mapState, mapAction)(withRouter(ActiveTodayTable));
